var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"scrollable":"","value":_vm.value,"eager":_vm.eager,"max-width":_vm.maxWidth,"persistent":"","fullscreen":_vm.showFullscreen},on:{"click:outside":_vm.closeDialog}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }